module.exports = __webpack_public_path__ + "img/13.8a556c67.png";